import palette from '../palette';
import typography from '../typography';

export default {
  styleOverrides: {
    root: {
      ...typography.body1,
      borderBottom: `1px solid ${palette.divider}`,
      padding: '16px',
    },
    head: {
      backgroundColor: palette.background.default,
      fontWeight: 600,
      color: palette.text.primary,
      borderBottom: `2px solid ${palette.divider}`,
    },
    body: {
      fontSize: '0.875rem',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      }
    }
  }
};
